<template>
  <Catalog
    title="Категория занятости"
    name-label="Название"
    submit-error="Укажите название категории занятости."
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    :exact-id="exactId"
    v-on="$listeners"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
import Catalog from "../Catalog.vue";

export default {
  name: "EmploymentCategory",
  components: { Catalog },
  mixins: [ catalogs ],
  props: {
    exactId: { type: Number }
  },
  methods: {
    async fetchData(id) {
      return await this.getEmploymentCategoryById(id);
    },
    async putData(data) {
      return await this.putEmploymentCategory(data)
    },
    async postData(data) {
      return await this.postEmploymentCategory(data)
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/EmploymentCategories/EmploymentCategory.vue